import React from 'react';
import NavigationBar from './Navigation Bar/NavigationBar';
import { Outlet } from 'react-router-dom';

const WithNavBar = () => {
    return (
        <>
            <NavigationBar />
            <Outlet />
        </>
    );
};

export default WithNavBar;